import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { TNameTitle } from '@interfaces/common/common';
import { IPortalAvailableMilestonesDTO } from '@interfaces/portal/dto/taskManagementDTO';
import { IGetPortalTimelineDTO, IPortalTimelineDTO } from '@interfaces/portal/dto/timelineManagementDTO';
import { IProjectUser } from '@interfaces/portal/projects';

const {
	portalTimeline,
	portalTimelineStatuses,
	portalTimelinePriorities,
	portalTimelineAssigneesFilter,
	portalTimelineMilestonesFilter,
} = URL;

export const getPortalTimeline = ({
	sortDirection,
	sortFieldName,
	searchValue,
	status,
	priority,
	projectId,
	assignees,
	milestoneId,
	startDateText,
	endDateText,
}: IGetPortalTimelineDTO): Promise<IPortalTimelineDTO> => {
	return client.get(portalTimeline, {
		params: {
			sortDirection,
			sortFieldName,
			searchValue,
			status,
			priority,
			projectId,
			assignees,
			milestoneId,
			startDateText,
			endDateText,
		},
		paramsSerializer: params =>
			qs.stringify(
				Object.fromEntries(
					Object.entries(params).filter(([_, value]) => value !== null && value !== undefined),
				),
				{ indices: false },
			),
	});
};

export const getPortalTimelineStatuses = (projectId?: string): Promise<TNameTitle[]> => {
	return client.get(portalTimelineStatuses, {
		params: {
			projectId,
		},
	});
};

export const getPortalTimelinePriorities = (): Promise<TNameTitle[]> => {
	return client.get(portalTimelinePriorities);
};

export const getPortalTimelineAssigneesForFilter = (projectId: string): Promise<IProjectUser[]> => {
	return client.get(portalTimelineAssigneesFilter, {
		params: {
			projectId,
		},
	});
};

export const getPortalTimelineMilestonesForFilter = (projectId: string): Promise<IPortalAvailableMilestonesDTO[]> => {
	return client.get(portalTimelineMilestonesFilter, {
		params: {
			projectId,
		},
	});
};
